<!-- v1.5 -->
<template>
  <section
    :class="{ 'hide-filter-bar': displayFilters === false }"
    class="ctpx-collection-grid ctpx-collection-grid-standard"
    id="collectionGrid"
  >
    <div class="ctpx-grid-container">
      <div id="standardCollectionGrid" ref="collectionGrid">
        <div class="container-fluid" v-bind:class="sortSelected">
          <div class="toggler-container">
            <div
              class="toggler-row"
              id="togglerRow"
              :class="{ 'mobile-fixed': scrolled }"
            >
              <div
                class="filter-sort"
                v-bind:class="{ 'drawer-toggled': isDrawerOpen }"
              >
                <a
                  class="filter-toggler"
                  v-bind:class="{ 'filter-toggled': isDrawerOpen }"
                  v-on:click="isDrawerOpen = !isDrawerOpen"
                  ><span class="hide-filters">Hide Filters</span
                  ><span class="show-filters">Filter</span>
                  <span class="line l1"></span><span class="line l2"></span
                  ><span class="line l3"></span
                ></a>
                <div class="sort">
                  <div
                    class="sort-dropdown"
                    v-bind:class="{ 'sort-open': isSortOpen }"
                  >
                    <a
                      class="sort-button"
                      role="button"
                      id="dropdownSort"
                      v-on:click="isSortOpen = !isSortOpen"
                    >
                      Sort By <span>{{ selectedSortOption }}</span>
                    </a>
                    <div class="sort-drop">
                      <div
                        class="form-check"
                        v-for="option in sortOptions"
                        :key="option.text"
                      >
                        <input
                          class="form-check-input"
                          type="radio"
                          :value="option.value"
                          name="sortby"
                          :id="option.value"
                          v-model="selectedSortOption"
                        />
                        <label class="form-check-label" :for="option.value">
                          {{ option.text }}
                        </label>
                      </div>
                    </div>
                    <!-- .sort-drop -->
                  </div>
                </div>
                <!-- sort -->
              </div>
              <!-- .filter-sort -->
              <a
                class="grid-toggler"
                v-bind:class="{ 'grid-view': isGridView }"
                v-on:click="isGridView = !isGridView"
              >
                <span class="gv-big"></span>
                <span class="gv-small"></span> </a
              ><!-- grid-toggler -->
            </div>
            <!-- toggler-row -->
          </div>
          <!-- toggler-container -->

          <div
            class="product-grid-container"
            v-bind:class="{ 'drawer-toggled': isDrawerOpen }"
          >
            <CollectionFilters
              :initialFilters="filters"
              :collectionId="collectionId"
              :products="products"
              @options-change="(data) => (selectedOptions = data)"
              @drawer-close="isDrawerOpen = false"
              @products-change="updateFilteredProducts"
              :minPrice="minPrice"
              :maxPrice="maxPrice"
              :priceFilterIsActive="priceFilterIsActive"
              @update-price-filter="(data) => (priceRange = data)"
              ref="filters"
            ></CollectionFilters>
            <div
              v-if="showProducts"
              class="product-grid"
              v-bind:class="{ 'grid-view': isGridView }"
              ref="productGrid"
              id="anchor-product-grid"
            >
              <div class="row breadcrumb-pill-row">
                <div class="col-9 col-lg-10">
                  <div class="breadcrumb-pills">
                    <div class="breadcrumb-overflower">
                      <div
                        v-for="option in selectedOptions"
                        :key="option.label + '-' + option.filterId"
                      >
                        <button
                          class="badge badge-default"
                          @click="unselectOption(option)"
                        >
                          <!-- need to display "value" for color filter, otherwise "label" works -->
                          {{
                            option.filterType === 'color'
                              ? option.value
                              : option.label
                          }}
                        </button>
                      </div>
                      <!-- badge for price filter -->
                      <div>
                        <button
                          class="badge badge-default"
                          @click="resetPriceFilter()"
                          v-if="priceFilterIsActive"
                        >
                          Price: ${{ priceRange[0] }} - ${{ priceRange[1] }}
                        </button>
                      </div>
                    </div>
                    <!-- breadcrumb-overflower -->

                    <button
                      class="badge badge-text"
                      v-if="
                        selectedOptions.length > 1 ||
                        (priceFilterIsActive && selectedOptions.length === 1)
                      "
                      @click="clearFilters()"
                    >
                      Clear All
                    </button>
                  </div>
                  <!-- .breadcrumb-pills -->
                </div>
                <!-- .col -->
                <div class="col-3 col-lg-2 text-right">
                  <div class="results-total">
                    {{ filteredProducts.length }} Results
                  </div>
                  <!-- .results-total -->
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
              <div class="row product-grid-row">
                <div v-if="!filteredProducts.length" class="col text-center">
                  <div class="special-search-icon"></div>
                  <h1>No items found</h1>
                  <p>
                    Please try removing some filters <br />or refresh the page
                    and try again.
                  </p>
                </div>
                <!-- ========== MINIMIZED GRID 1  ========== -->
                <!-- Load The First 12 Prods -->
                <template
                  v-for="(product, index) in sortedProducts.slice(0, 12)"
                >
                  <template v-for="n in cBanner.length">
                    <!-- 1 Content Banner (shown every 6th spot) -->
                    <div
                      class="col-sm-6 col-lg-4"
                      v-bind:class="{ 'col-6': isGridView }"
                      v-if="
                        !productsFiltered && cBanner.length === 1 && index === 5
                      "
                      :key="'cban1-' + index"
                    >
                      <ContentBannerCard
                        :cBanner="cBanner[0]"
                      ></ContentBannerCard>
                    </div>
                    <!-- .col -->
                    <!--Multiple Content Banners (shown every 4th spot) -->
                    <div
                      class="col-sm-6 col-lg-4"
                      v-bind:class="{ 'col-6': isGridView }"
                      v-if="
                        !productsFiltered &&
                        cBanner.length > 1 &&
                        index === n * 3
                      "
                      :key="'cban-' + index"
                    >
                      <ContentBannerCard
                        :cBanner="cBanner[n - 1]"
                      ></ContentBannerCard>
                    </div>
                    <!-- .col -->
                  </template>

                  <div
                    v-if="
                      product.colorways.length > 0 ||
                      product.choiceInventory === 'choice'
                    "
                    class="col-sm-6 col-lg-4"
                    v-bind:class="{ 'col-6': isGridView }"
                  >
                    <ProductCard :product="product" />
                  </div>
                </template>
                <!-- Load More Button -->
                <div
                  class="col-sm-12 text-center"
                  v-if="sortedProducts.length > 12 && showTheRest == false"
                >
                  <button class="btn btn-default sentinel" @click="loadingClicked()" ref="loadMoreTrigger">
                    {{ buttonText }}
                  </button>
                  
                  <p v-if="loading">Loading more products...</p>
                </div>
                <!-- .col-sm-12 -->
                <!-- Load the Rest of the Products -->
                <template
                  v-for="(product, index) in sortedProducts.slice(12)"
                  v-if="showTheRest"
                >
                  <div
                    v-if="
                      product.colorways.length > 0 ||
                      product.choiceInventory === 'choice'
                    "
                    class="col-sm-6 col-lg-4"
                    v-bind:class="{ 'col-6': isGridView }"
                  >
                    <ProductCard :product="product" />
                  </div>
                </template>
              </div>
              <!-- .row -->
            </div>
            <!-- show loading animation until product grid is ready-->
            <div v-else :style="{ width: '100%' }">
              <!-- <LoadingAnimation /> -->
              <div class="loading loading--plp-grid">
                <div class="row">
                  <div class="col-6 col-lg-4"><span></span></div><!-- .col -->
                  <div class="col-6 col-lg-4"><span></span></div><!-- .col -->
                  <div class="col-6 col-lg-4"><span></span></div><!-- .col -->
                  <div class="col-6 col-lg-4"><span></span></div><!-- .col -->
                  <div class="col-6 col-lg-4"><span></span></div><!-- .col -->
                  <div class="col-6 col-lg-4"><span></span></div><!-- .col -->
                </div><!-- .row -->
              </div>
            </div>
            <!-- .product-grid -->
          </div>
          <!-- product-grid-container -->
        </div>
        <!-- .container-fluid -->
      </div>
    </div>
    <!-- .ctpx-grid-container -->
  </section>
  <!-- .ctpx-collection-grid -->
</template>

<script src="./ctrl-standard-collection-grid.js"></script>
